export default __webpack_public_path__ + "static/media/lock_icon.0489e230.svg";